import { fontSize, fontWeight } from '@/styles/font'
import BaseHeading from './BaseHeading'
import { type HeadingProps } from './props'
import { memo } from 'react'

const Heading1 = (props: HeadingProps): JSX.Element => {
  return (
    <BaseHeading
      fontSize={fontSize.XXL}
      fontSizeSP={fontSize.L}
      fontWeight={fontWeight.Bold}
      {...props}
    >
      {props.children}
    </BaseHeading>
  )
}

export default memo(Heading1)
